import { createSlice } from "@reduxjs/toolkit";

const initialInventoryState = {
  listLoading: false,
  actionsLoading: false,
  statusListLoading: false,
  statusList: [],
  totalCount: 0,
  entities: [],
  inventoryForEdit: undefined,
  lastError: null,
  message: null,
  error: null,
};
export const callTypes = {
  list: "list",
  action: "action",
  statusList: "statusList",
};

export const inventorySlice = createSlice({
  name: "inventories",
  initialState: initialInventoryState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error.clientMessage;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else if(action.payload.callType === callTypes.statusList) {
        state.statusListLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      state.message = null;

      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else if(action.payload.callType === callTypes.statusList) {
        state.statusListLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    endCall: (state, action) => {
      state.error = null;
      state.message = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else if(action.payload.callType === callTypes.statusList) {
        state.statusListLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    // getInventoryById
    inventoryFetched: (state, action) => {
      state.actionsLoading = false;
      state.inventoryForEdit = action.payload.inventoryForEdit;
      state.error = null;
    },
    // getInventoryChart
    inventoryChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.inventoryChart = action.payload.inventoryChart;
      state.error = null;
    },
    // getInventoryChart
    inventoryHourlyChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.inventoryChartHour = action.payload.inventoryChartHour;
      state.error = null;
    },
    // getInventoryChart
    inventoryHourlyZoneChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.inventoryChartHourZone = action.payload.inventoryChartHourZone;
      state.error = null;
    },
    // get list data
    inventoriesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.inventoryForEdit = undefined;
      state.floorPlans = undefined;
      state.inventoryChart = undefined;
      state.inventoryChartHour = undefined;
      state.inventoryChartHourZone = undefined;
    },
    // createInventory
    inventoryCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.message = action.payload.msgResponse;
    },
    // updateInventory
    inventoryUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.message = action.payload.msgResponse;
    },
    // inventoryDeleted
    inventoryDeleted: (state, action) => {
      state.error = null;
      state.message = action.payload.msgResponse;
      state.actionsLoading = false;
    },
    printTag: (state,action) => {
      state.error = null;
      state.message = action.payload.msgResponse;
      state.actionsLoading = false;
    },
    inventoryStatusListFetched: (state,action) => {
      state.error = null;
      state.statusListLoading = false;
      state.statusList = action.payload.statusList;
    },
    setMessage: (state, action) => {
      state.error = null;
      state.message = action.payload.msgResponse;
    },
  },
});
